<template>
  <vs-table hover-flat v-if="callbacks && callbacks.length" :data="callbacks">

    <template slot="thead">
      <vs-th v-text="$t('no')"></vs-th>
      <vs-th v-text="$t('brand_name')"></vs-th>
      <vs-th v-text="$t('name')"></vs-th>
      <vs-th v-text="$t('number')"></vs-th>
      <vs-th v-text="$t('caller_amount')" v-if="$store.getters.hasCompanyPermission('company_can_use_callback_amount')"></vs-th>
      <vs-th v-text="$t('caller_id')" v-else></vs-th>
<!--      <vs-th v-text="$t('ivr_staff')"></vs-th>-->
      <vs-th v-text="$t('date')"></vs-th>
      <vs-th v-text="$t('time')"></vs-th>
      <vs-th v-text="$t('callbacks_ivr_press_number')"></vs-th>
      <vs-th v-text="$t('treatment_result')"></vs-th>
      <vs-th v-text="$t('progress_agent')"></vs-th>
      <vs-th v-text="$t('callback.name')"></vs-th>
      <vs-th v-text="$t('consulting_title')"></vs-th>
    </template>

    <template slot-scope="{data}">
      <vs-tr :key="indextr" v-for="(tr, indextr) in data">
        <vs-td v-text="tr.count" :data-tr-title="$t('no')"></vs-td>
        <vs-td v-text="tr.did_display_text" :data-tr-title="$t('brand_name')"></vs-td>
        <vs-td :data-tr-title="$t('name')">
          <a href="#" @click.prevent="$emit('openOutboundPopup', tr.member.id, tr.id, tr.ivr_dst, tr.members.length)" v-if="tr.member">
            {{ tr.member.name || '--' }}
          </a>
          <a href="#" @click.prevent="$emit('openOutboundPopup', 'new', tr.id, tr.ivr_dst, tr.members.length)" v-else>{{ $t('non_members') }}</a>
        </vs-td>
        <vs-td :data-tr-title="$t('number')">
          <span v-text="tr.caller_id" />
          <span v-if="$store.getters.hasCompanyPermission('company_can_use_callback_share_function')" v-text="` (${tr.totalCalls})`" />
        </vs-td>
        <vs-td :data-tr-title="$t('caller_amount')" v-if="$store.getters.hasCompanyPermission('company_can_use_callback_amount')">
          <span v-text="$t('caller_id_callback_amount_text')" v-if="tr.ivr_dst === '' || tr.ivr_dst === null" />
          <span v-text="tr.ivr_dst" v-else />
        </vs-td>
        <vs-td :data-tr-title="$t('caller_id')" v-text="tr.ivr_dst" v-else></vs-td>
<!--        <vs-td v-text="tr.ivr_press_number"></vs-td>-->
        <vs-td v-text="tr.call_date" :data-tr-title="$t('date')"></vs-td>
        <vs-td v-text="tr.call_time" :data-tr-title="$t('time')"></vs-td>
        <vs-td v-text="tr.ivr_press_number" :data-tr-title="$t('callbacks_ivr_press_number')"></vs-td>
        <vs-td :data-tr-title="$t('treatment_result')">
          <span @mouseover="tr.mouseover=1" @mouseleave="tr.mouseover=0" style="min-width:130px; line-height:40px;">
            <span v-if="tr.mouseover==0">
              <span v-if="tr.type != ''">
                <span class="text-primary" v-if="tr.type == 'A'" v-text="$t('treatment_result_receipt')"></span>
                <span class="text-success" v-else-if="tr.type == 'B'" v-text="$t('treatment_result_progress')"></span>
                <span class="text-warning" v-else-if="tr.type == 'C'" v-text="$t('treatment_result_waiting')"></span>
                <span class="text-default" v-else-if="tr.type == 'D'" v-text="$t('treatment_result_complete')"></span>
                <span v-else>&nbsp;</span>
                <span v-if="tr.is_seen == 0">&nbsp;</span>
                <span v-if="tr.is_seen == 0">New</span>
              </span>
              <span v-else>
                <span v-if="tr.is_seen == 0">New</span>
                <span v-else>&nbsp;</span>
              </span>
            </span>
            <span v-else>
              <select v-model="tr.result_type_id" class="vs-inputx vs-input--input normal hasValue" @change="$emit('updateTreatmentResult', indextr, tr);tr.is_seen = 1">
                <option value="" v-text="$t('please_select')"></option>
                <option v-for="(option, key) in resultOptions" :key="'results_' + key" :value="option.value">{{ option.label }}</option>
              </select>
            </span>
          </span>
        </vs-td>
        <vs-td :data-tr-title="$t('progress_agent')">
          <span v-text="tr.assigned_agent_name" v-if="tr.type == 'A' || tr.type == 'B' || tr.type == 'C'"></span>
        </vs-td>
        <vs-td :data-tr-title="$t('callback.name')">
          <span v-text="tr.assigned_agent_name" v-if="tr.type == 'D'"></span>
        </vs-td>
        <vs-td :data-tr-title="$t('consulting_title')">
          {{ $stringHelper.limitString(tr.title, 10) }}
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
  <vs-alert v-else class="flex justify-center p-0 h-auto" color="danger" active="true">
    <div v-text="$t('no_record')"></div>
  </vs-alert>
</template>

<script>


export default {
  name: 'Shared.Consultations.Callbacks.List',
  props: {
    callbacks: {
      type: [Object, Array],
      required: true
    },
    resultOptions: {
      type: [Object, Array],
      required: true
    }
  }
}
</script>

<style scoped>

</style>
